import TargetMatcher from "../../../match/TargetMatcher"
import ExperimentLocalEvaluateRequest from "../mode/local/ExperimentLocalEvaluateRequest"
import { EvaluatorContext } from "../../../evaluator/Evaluator"

export default class ExperimentTargetDeterminer {
  private readonly targetMatcher: TargetMatcher

  constructor(targetMatcher: TargetMatcher) {
    this.targetMatcher = targetMatcher
  }

  isUserInExperimentTarget(request: ExperimentLocalEvaluateRequest, context: EvaluatorContext): boolean {
    if (request.experiment.targetAudiences.length === 0) {
      return true
    }

    return request.experiment.targetAudiences.some((it) => this.targetMatcher.matches(request, context, it))
  }
}
